import { isStaffEmail } from "@utils/user_utils";

const STORAGE_KEY = "dashalt_debug_features";

export interface DebugFlags {
  padTableRowData: boolean;
}

const DEFAULTS: DebugFlags = {
  padTableRowData: false,
};

export const DEBUG_FLAG_LABELS: Record<keyof DebugFlags, string> = {
  padTableRowData: "Pad Table Row Data",
};

export function isLocalhost(): boolean {
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h === "[::1]";
}

export function isInternalUser(email: string | undefined): boolean {
  return isStaffEmail(email);
}

export function getDebugFlags(): DebugFlags {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULTS;
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return DEFAULTS;
  }
}

export function setDebugFlags(flags: DebugFlags): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(flags));
}
